<div [class]="useDefaultCls ? 'component-container order-history-container' : ''">
  <div class="margin-align">
    <div class="margin-header-align text-uppercase page-title">{{ 'order-history.title' | translate }}</div>
  </div>

  <div class="accordions-container">
    <p-accordion [multiple]="true" styleClass="netz-accordion">
      <ng-container *ngFor="let data of paginatedOrderHistoryData; let index = index">
        <p-accordionTab [(selected)]="data.tabSelected">
          <p-header>
            <div class="ui-g-12">
              <span class="ui-g-10 no-padding">
                {{ data.technician_id ? data.technician : ('order-history.system-event' | translate) }} -
                {{ data.log_date | stringifiedDate }}
              </span>
              <div *ngIf="showCommentModifierSection(data)" class="ui-g-2 no-padding action-container">
                <div (click)="editComment($event, data, index)" [ngClass]="{ disable: isEdit || isNewComment }" class="pointer-cursor">
                  <i class="pi pi-pencil"></i>
                </div>
                <div (click)="deleteComment($event, data.log_id)" class="pointer-cursor">
                  <i class="pi pi-trash"></i>
                </div>
              </div>
            </div>
            <div class="event-details">
              <span>{{ 'lookup.' + eventTypeKey + '.options.' + data[eventTypeKey] + '.name' | translate }}</span>
            </div>
          </p-header>
          <div class="ui-g details-content">
            <div *ngIf="!isEdit || selectedLogId !== data.log_id" class="ui-g-7 no-padding">
              <pre [innerHTML]="data.details"></pre>
            </div>
            <div *ngIf="isEdit && selectedLogId === data.log_id" class="ui-g-7">
              <label for="inline-comment"></label>
              <ng-container *ngIf="environmentService.showWordFormat">
                <quill-editor
                  [styles]="editorStyle"
                  placeholder="Enter Text"
                  [(ngModel)]="commentToEdit"
                  (ngModelChange)="onCommentChanged($event)"
                  [modules]="quillConfig"></quill-editor>
              </ng-container>
              <ng-container *ngIf="!environmentService.showWordFormat">
                <textarea
                  [(ngModel)]="commentToEdit"
                  [maxlength]="maxCommentLength"
                  class="ui-g-12 comment-box"
                  cols="20"
                  id="inline-comment"
                  rows="5"></textarea>
              </ng-container>
              <div class="ui-g-5 button-rows">
                <button
                  (click)="updateOrderHistory()"
                  [disabled]="!commentToEdit.length"
                  class="submit-button"
                  label="{{ 'order-history.save-button-label' | translate }}"
                  pButton
                  type="button"></button>
                <button
                  (click)="discardInlineEdit()"
                  class="cancel-button"
                  label="{{ 'order-history.cancel-button-label' | translate }}"
                  pButton
                  type="button"></button>
              </div>
            </div>
          </div>
        </p-accordionTab>
      </ng-container>
      <div *ngIf="pagination" class="card flex justify-content-center">
        <p-paginator
          (onPageChange)="onPageChange($event)"
          [rows]="paginator.rows"
          [first]="paginator.first"
          [totalRecords]="orderHistoryData.length"
          [rowsPerPageOptions]="[30, 50, 100]"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} - {last} of {totalRecords} entries"></p-paginator>
      </div>
    </p-accordion>
  </div>

  <button
    (click)="addNewComment()"
    *ngIf="showCommentButton && !isNewComment"
    class="ui-g-3 new-comment-button"
    label="{{ 'order-history.comment-button-label' | translate }}"
    pButton
    type="button"
    [disabled]="isEdit"></button>
  <div *ngIf="isNewComment && orderHistoryFG" class="ui-g-10 comment-section">
    <form [formGroup]="orderHistoryFG">
      <label class="ui-g-6" for="user-comment">{{ 'order-history.new-comment' | translate }}</label>
      <div class="ui-g-7">
        <ng-container *ngIf="environmentService.showWordFormat">
          <quill-editor [styles]="editorStyle" placeholder="Enter Text" formControlName="newComment" [modules]="quillConfig"></quill-editor>
        </ng-container>
        <ng-container *ngIf="!environmentService.showWordFormat">
          <textarea
            formControlName="newComment"
            [maxlength]="maxCommentLength"
            class="ui-g-12 comment-box"
            cols="20"
            id="user-comment"
            rows="5"></textarea>
        </ng-container>
      </div>
    </form>

    <div class="ui-g-5 button-rows">
      <button
        (click)="createOrderHistory()"
        [disabled]="orderHistoryFG.invalid"
        class="submit-button"
        label="{{ 'order-history.save-button-label' | translate }}"
        pButton
        type="button"></button>
      <button
        (click)="discardNewComment()"
        class="cancel-button"
        label="{{ 'order-history.cancel-button-label' | translate }}"
        pButton
        type="button"></button>
    </div>
  </div>
</div>

<p-confirmDialog
  #deleteConfirmDialog
  icon="pi pi-info-circle"
  message="{{ 'messages.delete-confirmation-message' | translate }}"
  styleClass="netz-confirm-dialog">
  <p-footer>
    <button (click)="deleteConfirmDialog.accept()" label="{{ 'yes-button-label' | translate }}" pButton type="button"></button>
    <button (click)="deleteConfirmDialog.reject()" label="{{ 'no-button-label' | translate }}" pButton type="button"></button>
  </p-footer>
</p-confirmDialog>

<app-loader *ngIf="isLoading"></app-loader>
